import React from "react";
import ReactDOM from "react-dom";
import ReactKalturaResumableExample from './components/ReactKalturaResumableExample';

// Render the main component into the dom
ReactDOM.render(<ReactKalturaResumableExample />, document.getElementById('root'));


/** WEBPACK FOOTER **
 ** index.js
 **/